document.addEventListener("DOMContentLoaded", () => {
  swapColorsOnMobile();

  window.addEventListener("resize", () => {
    swapColorsOnMobile();
  });

  function isMobile() {
    return window.innerWidth < 750;
  }
  
  function swapColorsOnMobile() {
    const secondColorsOnMobile = document.querySelectorAll(
      ".theme-second-colors-on-mobile"
    );
    if (isMobile()) {
      secondColorsOnMobile
        ? secondColorsOnMobile.forEach((content) => {
            content.classList.add(
              content.getAttribute("data-color-scheme-mobile")
            );
          })
        : null;
    } else {
      secondColorsOnMobile
        ? secondColorsOnMobile.forEach((content) => {
            content.classList.remove(
              content.getAttribute("data-color-scheme-mobile")
            );
          })
        : null;
    }
  }
});